import React, { useState } from 'react'
import { Form, Radio } from 'antd'
import { useTranslation } from 'react-i18next'

const AspectRatioSelector = ({ form, disabled }) => {
  const { getFieldDecorator, setFieldsValue } = form
  const [selectedRatio, setSelectedRatio] = useState('default')
  const { t } = useTranslation()

  const handleAspectRatioChange = ratio => {
    setSelectedRatio(ratio)
    setFieldsValue({ aspectRatio: ratio })
  }

  const aspectRatios = [
    { value: 'default', label: '1:1', width: 48, height: 48 },
    { value: '16:9', label: '16:9', width: 70, height: 40 },
    { value: '4:3', label: '4:3', width: 60, height: 45 },
    { value: '3:4', label: '3:4', width: 45, height: 60 },
    { value: '9:16', label: '9:16', width: 40, height: 70 },
    { value: '3:2', label: '3:2', width: 65, height: 44 },
    { value: '2:3', label: '2:3', width: 44, height: 65 },
    { value: '2:1', label: '2:1', width: 76, height: 38 }
  ]

  return (
    <Form.Item label={`📐 ${t('infographic:aspect_ratio')}`} className="nbai-ar-selector">
      {getFieldDecorator('aspectRatio', {
        initialValue: 'default'
      })(
        <Radio.Group disabled={disabled} className="nbai-ar-hidden-group">
          {aspectRatios.map(ratio => (
            <Radio
              key={ratio.value}
              value={ratio.value}
              className="nbai-ar-hidden"
            />
          ))}
        </Radio.Group>
      )}

      <div className="nbai-ar-grid">
        {aspectRatios.map(ratio => (
          <div
            key={ratio.value}
            className={`nbai-ar-option ${selectedRatio === ratio.value ? 'selected' : ''}`}
            onClick={() => !disabled && handleAspectRatioChange(ratio.value)}
          >
            <div
              className="nbai-ar-preview"
              style={{
                width: ratio.width,
                height: ratio.height,
                opacity: disabled ? 0.5 : 1
              }}
            >
              <div className="nbai-ar-image">
                <div className="nbai-ar-mountains"></div>
                <div className="nbai-ar-sky"></div>
              </div>
            </div>
            <div className="nbai-ar-label">{ratio.label}</div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .nbai-ar-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 8px;
          margin-top: 4px;
        }
        
        @media (max-width: 920px) {
          .nbai-ar-grid { grid-template-columns: repeat(4, 1fr); }
        }

        .nbai-ar-hidden-group {
          display: none;
        }

        .nbai-ar-option {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: ${disabled ? 'not-allowed' : 'pointer'};
          padding: 4px;
          border-radius: 8px;
          transition: all 0.2s;
          border: 1px solid #e5e7eb;
          background: #ffffff;
        }

        .nbai-ar-option.selected {
          background-color: #eef4ff;
          border: 1px solid #136cfb;
        }

        .nbai-ar-preview {
          position: relative;
          overflow: hidden;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
          margin-bottom: 4px;
          background: #f8fafc;
        }

        .nbai-ar-image {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }

        .nbai-ar-sky {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 60%;
          background: linear-gradient(to bottom, #87ceeb, #add8e6);
        }

        .nbai-ar-mountains {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 40%;
          background: linear-gradient(to bottom, #6b8e23, #2e8b57);
          clip-path: polygon(0% 100%, 30% 40%, 70% 70%, 100% 20%, 100% 100%);
        }

        .nbai-ar-label {
          font-size: 11px;
          text-align: center;
          color: #475569;
        }
      `}</style>
    </Form.Item>
  )
}

export default AspectRatioSelector
